import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IConsumptionHistory } from '@mwe/models';
import { EnvironmentService } from '../environment/environment.service';
import { lastValueFrom } from 'rxjs';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';

@Injectable({
  providedIn: 'root',
})
export class ConsumptionDataService {
  private http = inject(HttpClient);
  private environmentService = inject<EnvironmentService>(ENVIRONMENT_SERVICE_TOKEN);

  private resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/consumption/';
  }

  getConsumptionHistoryMonthly(accountNumber: string, systemId: string): Promise<IConsumptionHistory> {
    return lastValueFrom(this.http.get<IConsumptionHistory>(this.resourceUrl + accountNumber + '/history/monthly?systemId=' + systemId));
  }

  getConsumptionHistory(accountNumber: string, systemId: string): Promise<IConsumptionHistory> {
    return lastValueFrom(
      this.http.get<IConsumptionHistory>(this.resourceUrl + accountNumber + '/consumption/history?systemId=' + systemId),
    );
  }
}
